import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-transfer-in-progress',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './transafer-in-progress.component.html',
  styleUrl: './transafer-in-progress.component.css'
})
export class TransferInProgress {

  constructor(private router:Router) {}
  retry() {
    this.router.navigate(['/authorize']);
    console.log('Retry clicked');
  }

}
